import type Client from '../client'
import type {
  ErrorAble,
  SupplierGalleryParameters,
  SupplierGalleryResponse,
  SupplierImageResponse,
} from '@/api'

export default class SupplierGallery {
  constructor(private supplierId: number, private client: Client) {}

  all(): Promise<ErrorAble<SupplierGalleryResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.get(`supplier/${this.supplierId}/gallery`))
      } catch (error) {
        reject(error)
      }
    })
  }

  create(
    data: SupplierGalleryParameters,
    headers: RequestInit['headers'] = {},
  ): Promise<ErrorAble<SupplierImageResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          await this.client.post(`supplier/${this.supplierId}/gallery`, {
            data,
            headers,
          }),
        )
      } catch (error) {
        reject(error)
      }
    })
  }

  update(
    id: number,
    data: SupplierGalleryParameters,
  ): Promise<ErrorAble<SupplierImageResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          await this.client.put(`supplier/${this.supplierId}/gallery/${id}`, {
            data,
          }),
        )
      } catch (error) {
        reject(error)
      }
    })
  }
}
